export const HEADING = 'Hang Tight!';

export const SUBHEADING =
  "We're just processing your subscription. This should only take a few seconds. If you've been here for more than a minute, try refreshing the page or contact Ideal4Finance";
